/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'local': {
    width: 16,
    height: 16,
    viewBox: '0 0 44.71 56.17',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M44.21 22.35a21.85 21.85 0 0 0-43.71 0c0 7.75 4.21 15.75 11.28 23.52a78.77 78.77 0 0 0 7.87 7.5c.46.39 2.71 2.17 2.71 2.17s2.24-1.77 2.71-2.17a78.77 78.77 0 0 0 7.87-7.5"/><path pid="1" class="cls-1" d="M22.35 35.47a13.11 13.11 0 1 1 13.12-13.12 13.11 13.11 0 0 1-13.12 13.12z"/><path pid="2" class="cls-1" d="M32.93 45.87a78.77 78.77 0 0 1-7.87 7.5c-.47.39-2.71 2.17-2.71 2.17s-2.25-1.78-2.71-2.17a78.77 78.77 0 0 1-7.87-7.5C4.71 38.11.5 30.1.5 22.35a21.85 21.85 0 0 1 43.71 0 26.79 26.79 0 0 1-3.08 11.93"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/local.js